
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { Nav, Navbar, Dropdown, Container } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from "../context/AuthContext";
import { Routes } from "../routes";

export default () => {
  const { tenantId, tenantName, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const displayName = tenantName || (tenantId ? `${tenantId.slice(0, 8)}…` : 'Workspace');

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center">
            <span className="text-muted small d-none d-md-inline">Risk decisioning console</span>
          </div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <div className="icon icon-shape icon-sm icon-primary rounded-circle me-2">
                    <FontAwesomeIcon icon={faUserShield} />
                  </div>
                  <div className="media-body text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{displayName}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item as={Link} to={Routes.Account.path} className="fw-bold">
                  Account settings
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
